import React, { Component } from 'react';
import Header from './Layout/Header';
import { connect } from 'react-redux';
import RoomTable from '../Component/RooManagementCommon/RoomTable';
import RoomFilter from '../Component/RooManagementCommon/RoomFilter';
import AddRoom from '../Component/RooManagementCommon/AddRoom';
import Sidebar from "../Component/Layout/Sidebar";
import CustomHeader from "../Component/Layout/Header";
import { Layout } from "antd";

import { RoomMaList, CheckLoader } from '../Redux/action/roomTraingAction';
import { dataUser } from './Helpers/util';
import { Navigate } from 'react-router-dom';
import MarketingPanel from '../Component/MarketingPanel';
import { getServiceAccess } from '../Redux/action/userActions';
import axiosInstance from '../utils/axiosInstance';
import mixpanel from 'mixpanel-browser';
import SwIconButton from './Common/SwIconButton/SwIconButton';
import AntDDropdown from './Common/AntDDropdown/AntDDropdown';
import SwLoader from './Common/SwLoader/SwLoader';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const { Content } = Layout;

class RoomManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company_id: UserObj ? UserObj.company_id : null,
      filterData: {},
      pageOffset: 1,
      pageSize: 25,
      dropdown: false,
      trainingRoomList: [],
      locationSpoc: [],
      loader: false,
      sort_by: '',
      isSearchVisible: false,
      searchText: '',
      accessServiceLists: [],
      loaderServiceAccess: true,
      userRole: UserObj && UserObj.role_data ? UserObj.role_data : [],
      userRole: [], 
      collapsed: true,
    };
    this.forwordPage = this.forwordPage.bind(this);
    this.pageBackword = this.pageBackword.bind(this);
    this.handelDropdown = this.handelDropdown.bind(this);
  }

  toggleSearchHandler = () => {
    const isVisible = this.state.isSearchVisible;
    this.setState({
      isSearchVisible: !isVisible,
    });
  };

  toggleCollapsed = () => {

    this.setState((prevState) => ({ collapsed: !prevState.collapsed }));
  };


  handleLanguage = langValue => {
    this.setState({
      filterData: langValue,
    });
  };



  async componentDidMount() {
      const userDataLocal = dataUser(); // Fetch user data
    
        if (userDataLocal) {
          try {
            const UserObj = JSON.parse(userDataLocal);
            this.setState({
              userRole: UserObj.role_data || [], // Ensure it's always an array
            });
          } catch (error) {
            console.error("Error parsing user data:", error);
          }
        }
    try {
      await this.fetchLocationData(); // This will internally call updateUserList
    } catch (error) {
      console.error("Error in componentDidMount:", error);
    }
  }
  
  fetchLocationData = async () => {
    try {
      const axiosConfig = {
        params: {
          spoc: UserObj.rec_id,
          client: this.state.company_id,
        },
       
      };
  
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/basic-data/get-location-by-spoc`,
        axiosConfig
      );
  
      if (response.data.status === "success") {
        this.setState(
          { locationSpoc: response.data.data || [] }, 
          this.updateUserList // This will now be called only once
        );
      } else {
        this.setState({ locationSpoc: [] });
      }
    } catch (error) {
      console.error("Error fetching location data:", error);
      this.setState({ locationSpoc: [] });
    }
  };
  
  updateUserList = () => {
    const authData = JSON.parse(localStorage.getItem("headData"));
    if (!authData?.organizationId) return;
  
    const { pageOffset, pageSize, filterData, SortData, locationSpoc } = this.state;
  
    const param = {
      pageOffset,
      pageSize,
      type: ["Meeting Room", "Conference Room", "Training Room", "AV Lounge"],
      includes: "KPI",
      propertyId: locationSpoc.map((item) => item.newId),
      reqFrom: "cspoc",
      clientId: [authData.organizationId],
      ...filterData,
      ...SortData,
    };
  
    this.props.RoomMaList(param);
    this.props.CheckLoader();
  };
  
setSelectsort = (key) => {
  this.setState(
    {
      sort_by: key,
      pageOffset: 1,
    },
    () => {
      const newCompanyId = JSON.parse(localStorage.getItem("headData"));

      const params = {
        pageOffset: 1,
        pageSize: this.state.pageSize,
        includes: "KPI",
        reqFrom: "cspoc",
        clientId: [newCompanyId.organizationId],
        propertyId: this.state.locationSpoc?.map((item) => item.newId),
        type: [
          "Meeting Room",
          "Conference Room",
          "Training Room",
          "AV Lounge",
        ],
        sortBy:
          key === "pricelh" || key === "pricehl"
            ? "pricePerSlot"
            : key === "status"
            ? "isActive"
            : key === "rtype"
            ? "type"
            : key,
        orderBy:
          key === "pricelh"
            ? "asc"
            : key === "pricehl"
            ? "desc"
            : "desc",
      };

      this.props.CheckLoader();
      this.props.RoomMaList(params);
      this.setState({ SortData: params });
    }
  );
};

  handelDropdown() {
    this.setState({
      dropdown: !this.state.dropdown,
    });
  }
  selectRows = (e) => {
    const newCompanyId = JSON.parse(localStorage.getItem("headData"));
    const newPageSize = e.target.value;
  
    this.setState((prevState) => {
      const param = {
        pageOffset: prevState.pageOffset,
        includes: "KPI",
        pageSize: newPageSize,
        propertyId: prevState.locationSpoc?.map((item) => item.newId),
        reqFrom: "cspoc",
        clientId:[newCompanyId.organizationId],
        type: ["Meeting Room", "Conference Room", "Training Room", "AV Lounge"],
        ...prevState.filterData, // ✅ Include filters
        ...prevState.SortData, // ✅ Include sorting
      };
  
      this.props.RoomMaList(param);
      this.props.CheckLoader();
  
      return {
        pageSize: newPageSize,
        filterData: { ...prevState.filterData, pageSize: newPageSize },
        SortData: { ...prevState.SortData, pageSize: newPageSize },
      };
    });
  };

  forwordPage() {
    const { pageOffset, pageSize, trainingRoomList, filterData, SortData } = this.state;
    const newCompanyId = JSON.parse(localStorage.getItem("headData"));
  
    if (trainingRoomList.length < pageSize) return; // Prevent extra page request
  
    const newPageOffset = pageOffset + 1; // ✅ Increment page number
  
    this.setState({ pageOffset: newPageOffset }, () => {
      const param = {
        ...SortData, // ✅ Keep sorting applied
        ...filterData, // ✅ Keep filters applied
        pageOffset: newPageOffset, // ✅ Use updated page
        pageSize: this.state.pageSize,
        type: ["Meeting Room", "Conference Room", "Training Room", "AV Lounge"],
        propertyId: this.state.locationSpoc?.map((item) => item.newId),
        reqFrom: "cspoc",
          clientId:[newCompanyId.organizationId],
      };
  
      this.props.RoomMaList(param);
      this.props.CheckLoader();
    });
  }
  
  pageBackword() {
    const { pageOffset, filterData, SortData } = this.state;
    const newCompanyId = JSON.parse(localStorage.getItem("headData"));
  
    if (pageOffset === 1) return; // Prevent going below page 1
  
    const newPageOffset = pageOffset - 1; // ✅ Decrement page number
  
    this.setState({ pageOffset: newPageOffset }, () => {
      const param = {
        ...SortData, // ✅ Keep sorting applied
        ...filterData, // ✅ Keep filters applied
        pageOffset: newPageOffset, // ✅ Use updated page
        pageSize: this.state.pageSize,
        type: ["Meeting Room", "Conference Room", "Training Room", "AV Lounge"],
        propertyId: this.state.locationSpoc?.map((item) => item.newId),
        reqFrom: "cspoc",
        clientId:[newCompanyId.organizationId],
      };
  
      this.props.RoomMaList(param);
      this.props.CheckLoader();
    });
  }
  




  clearSearchBox = () => {
    this.setState({ searchText: '' });
  };



  refreshPage = e => {
    const newCompanyId = JSON.parse(localStorage.getItem('headData'));
    const param = {
      pageOffset: 1,
      pageSize: 25,
      type: [
        "Meeting Room",
        "Conference Room",
        "Training Room",
        "AV Lounge"
    ],
      includes: "KPI",
      propertyId: this.state.locationSpoc?.map((item) => item.newId), 
      reqFrom: "cspoc",
      clientId:[newCompanyId.organizationId],
    
    };
    this.props.RoomMaList(param);
  };

  componentWillReceiveProps(props) {
    if (
      props.roomTraingReducer &&
      props.roomTraingReducer.RoomTrainingData &&
      props.roomTraingReducer.RoomTrainingData.status == 200
    ) {
      this.setState({
        trainingRoomList:
          props.roomTraingReducer &&
          props.roomTraingReducer.RoomTrainingData &&
          props.roomTraingReducer.RoomTrainingData.data &&
          props.roomTraingReducer.RoomTrainingData.data.data,
      });

      this.setState({
        loader: props.roomTraingReducer && props.roomTraingReducer.loader,
      });
    }
  }

  componentWillMount() {
    this.fetchServiceAccess();
  }

  fetchServiceAccess = async () => {
    const getCompanyId =UserObj.company_id;
    const response = await getServiceAccess(getCompanyId);
    this.setState({ accessServiceLists: response, loaderServiceAccess: false });
  }

  filterMixPanel = () => {
    mixpanel.track('Reports MR filter', {
      PageName: 'MR Inventory',
      UserEmail: UserObj.email,
      UserName: UserObj.fname + ' ' + UserObj.lname,
      UserId: UserObj.rec_id,
      CompanyId: UserObj.company_id,
      CompanyName: UserObj.company_name,
      Type: 'MR Inventory',
    });
  }

  render() {
    const { userRole } = this.state;
    const RoomManagement = this.state.userRole.find(
      element =>
        element.service_id == '4' &&
        (element.role_for_read === '1' || element.role_for_write === '1'),
    );

    if (!RoomManagement) {

  
      // Redirect only if userRole has loaded and SupportTickets is missing
      if (userRole.length > 0 && !RoomManagement) {
        return <Navigate to="/Dashboard" />;
      }

    }


  

const sharfeData=this.state.trainingRoomList


    
    let serviceAccess = true;
    const serviceAccessId = 4;
    if (this.state.accessServiceLists.length > 0) {
      let serviceAccessobject = {};
      this.state.accessServiceLists.map(e => {
        if (e.id == serviceAccessId) serviceAccessobject = e;
      });
      serviceAccess = false;
      if (serviceAccessobject)
        serviceAccess = serviceAccessobject.service_access;
    }

    return (
      <>
     <Layout>
      
      <Sidebar collapsed={this.state.collapsed} />

      <CustomHeader collapsed={this.state.collapsed} toggleCollapsed={this.toggleCollapsed} />
      

      <Layout className={this.state.collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'}>
        {serviceAccess === true ?
          <>
         <div className="PageContent">
              <div className="row">
                <div class="col-md-6 col-lg-6">
                <div className='SwHeading'>
                  <h2 className='mb-0'>Meeting and Training Room Management</h2>
                </div>
                </div>
                <div className="col-md-12 col-lg-6">
                  <div className="PageHead_Optons_Row">
                    <ul className='PageHead_Optons_RightAligned'>
                      <li>
                        <RoomFilter
                          pg={this.state.pageOffset}
                          pgRowNumber={this.state.pageSize}
                          clearSearch={this.clearSearchBox}
                          srow={this.state.pageSize}
                          onSelectLanguage={this.handleLanguage}
                          onClick={this.filterMixPanel}
                        />
                      </li>
                           <li className="ToHideMobile">
                            <AntDDropdown
                              menu={{
                                onClick: ({ key }) => {
                                  if (['name','status','rtype' ,'pricelh', 'pricehl', ].includes(key)) {
                                    this.setSelectsort(key);
                                  }
                                  if (key === 'refresh') {
                                    this.refreshPage();
                                  }
                                },
                                items: [
                                  {
                                    key: 'sort',
                                    label: 'Sort by',
                                    icon: <i className="bi bi-sort-down-alt"></i>,
                                    children: [
                                      {
                                        key: 'name',
                                        label: 'Name',
                                        className: 'SortingMenu',
                                      },
                                      {
                                        key: 'status',
                                        label: 'Status',
                                        className: 'SortingMenu',
                                      },
                                      {
                                        key: 'rtype',
                                        label: 'Room Type',
                                        className: 'SortingMenu',
                                      },
                                      {
                                        key: 'pricelh',
                                        label: 'Price Low to High',
                                        className: 'SortingMenu',
                                      },
                                       {
                                        key: 'pricehl',
                                        label: 'Price High to Low',
                                        className: 'SortingMenu',
                                      },
                                    ],
                                  },

                                  {
                                    key: 'refresh',
                                    icon: <i className="bi bi-arrow-clockwise"></i>,
                                    label: 'Refresh List',
                                  },
                                ],
                              }}
                              trigger={['click']}
                              placement="bottomRight"
                            >
                              <SwIconButton size="sm">
                                <i className="bi bi-list" />
                              </SwIconButton>
                            </AntDDropdown>

                          </li>
                      <li>
                        <AddRoom
                          pgNumber={this.state.pageOffset}
                          pgRowNumber={this.state.pageSize}
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="mainAllTable">
                    <div
                      className={
                        this.state.loader == true ? 'loader disable' : 'loader'
                      }
                    >
                      <img
                        className=""
                        src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/loader-sw.gif"
                        alt="Loder"
                      />
                    </div>
         <RoomTable
  roomTraingList={this.state.trainingRoomList}
  pgNumber={this.state.pageOffset}
  pgRowNumber={this.state.pageSize}
  propertyId={this.state.locationSpoc?.map((item) => item.newId)}
/>
                  </div>
                </div>
              </div>
            </div>
          </>
          : this.state.loaderServiceAccess == true ? (

            <>

              <SwLoader />

            </>

          ) : <MarketingPanel />

        }
             </Layout>

</Layout>
      </>
    );
  }
}

const mapStateToProps = state => ({
  roomTraingReducer: state.roomTraingReducer,
});

const mapActionsToProps = {
  RoomMaList,
  CheckLoader,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(RoomManagement);
